import { urlWithParams, urlWithQuery } from './utils'
import { Method, PathParams, TypedAjaxResponse } from './types'
import { ajax } from 'rxjs/ajax'
import { store } from '../redux/store'
import { Observable, of } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { flow } from 'fp-ts/es6/function'
import { get } from 'es-cookie'
import { userActions } from '../redux/global/user/user-actions'
import { EmptyObject } from '../types/UtilityTypes'
import { errorToast } from '../components/controls/Toaster/Toaster'
import { MESSAGES } from '../constants/messages'
import { systemActions } from '../redux/global/system'

export enum ContentType {
    MULTIPART = 'multipart/form-data',
}

export const authProxyHandler: ProxyHandler<Record<string, string>> = {
    get(target, p: string): string {
        return (p === 'Authorization' ? store.getState().global.user.token : target[p])
    }
}

let firstVersionMismatch = true

function prepareAjax<R>(url: string, method: Method, headers?: Record<string, string>, type?: ContentType, body?: unknown) {
    const newHeaders = new Proxy(headers || {}, authProxyHandler)

    newHeaders['Authorization'] = store.getState().global.user.token
    newHeaders['X-XSRF-TOKEN'] = get('XSRF-TOKEN') || ''

    switch (type) {
        case ContentType.MULTIPART:
            break
        default:
            newHeaders['Content-Type'] = 'application/json'
    }

    return ajax({
        url,
        body,
        method,
        headers: newHeaders
    }).pipe(
        tap(res => {
            // version
            const version = localStorage.getItem('version') ?? ''
            const oldVersion = localStorage.getItem('old-version') ?? ''
            const newVersion = res.response.version
            if (version != newVersion) {
                if (version !== oldVersion) {
                    localStorage.setItem('old-version', version)
                    location.reload()
                } else {
                    if (firstVersionMismatch) {
                        firstVersionMismatch = false
                        errorToast(MESSAGES.VERSION_MISMATCH)
                    }
                }
            }
            // update
            const updateAt = store.getState().global.system.updateAt
            if (res.response.update_at && res.response.update_at !== updateAt) {
                store.dispatch(systemActions.startUpdate(res.response.update_at))
            }
        }),
        catchError(err => {
            if (err.status === 401) {
                store.dispatch(userActions.logout.success())
            }
            return of({ response: { success: false, message: 'Ошибка авторизации' } })
        }),
    ) as Observable<TypedAjaxResponse<R>>
}

interface RequestParams {
    method: Method,
    url: string,
    headers?: Record<string, string>,
    type?: ContentType,
}

export type RequestData<R extends EmptyObject = EmptyObject, D extends EmptyObject = EmptyObject, P extends PathParams = Record<string, string | number>, Q extends EmptyObject = EmptyObject> = {
    response?: R,
    data?: D,
    params?: P,
    query?: Q,
}

export function request<D extends RequestData>(c: RequestParams) {
    return (data: Omit<D, 'response'>): Observable<TypedAjaxResponse<D['response']>> => {
        return prepareAjax<D['response']>(
            flow(
                urlWithParams(data.params ?? {}),
                urlWithQuery(data.query ?? {})
            )(c.url),
            c.method,
            c.headers,
            c.type,
            data.data,
        )
    }
}
